import { Box, Divider, Paper, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import News from '../../components/tab/tabview/News'

export default function NewsComponent() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState('');


  return (
    <>
      <Typography sx={{ textAlign: 'center', m: 1, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{t('news')}</Typography>
      <Divider />
      <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", padding: 0, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <TextField size="small" variant="outlined" placeholder="Search here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1 }} />
          </Paper>
        </Box>
      </Box>
      <News searchQuery={searchQuery}/>
    </>)
}
